import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "../locales/en.json";
import vi from "../locales/vi.json";
import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
  en,
  vi
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: ['vi', 'en'],
    detection: {
      order: ['localStorage', 'htmlTag'],
      lookupLocalStorage: 'lang',
    },
    keySeparator: ".", // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;